<template>
    <div class="w-full">
      <!-- Custom video url -->
      <div class="flex flex-shrink w-full text-sm relative">
        <input type="text" id="custom-video-url" v-model="mediaUrl" @change="urlChange()" class="w-full mt-2 mb-6 ml-2 mr-8 p-2 border border-grey-dark">
        <a target="_blank" class="w-4 pt-2 absolute text-grey-light" style="top:.5em; right: 0; width: 2em; height: 1em" :href="mediaUrl">
          <icon name="link"></icon></a>
      </div>
      <!-- Upload FORM -->
      <div class="flex w-full relative items-center mb-2">
        <div class="w-1/2 border border-grey-dark p-4 ml-2" v-if="!filename">
          <div class="w-full bg-tertiary upload-helper text-center flex items-center justify-center rounded-lg" @drop.prevent="filesDropped($event, true)" @dragenter="overDropzone = true" @dragleave="overDropzone = false">
            <div class="dropzone" :class="{over: overDropzone}">
              <i class="fas fa-file-upload fa-4x block"></i>
              <h3 class="mt-5 mb-2">Upload Video</h3>
              <p>Drop your new video file here</p>
            </div>
          </div>
        </div>
        <div class="w-1/2 p-4 ml-2 border border-grey-dark" @drop.prevent="filesDropped($event, true)" @dragenter="overDropzone = true" @dragleave="overDropzone = false" v-else>
          <div class="w-full mb-5"  >
            <div class="float-right">
              <i class="fas fa-trash-alt cursor-pointer" title="Delete" @click="deleteVideo()"></i>
            </div>
            <div class="pb-2 font-bold">Uploaded Video:</div>
            <div class="p-4 dropzone" :class="{over: overDropzone}">
              <div class="px-4 py-2">{{filename}}</div>
              <div class="px-4">Size: {{mediaSize | sizeInMb}}Mb</div>
            </div>
          </div>
        </div>
        <div class="w-1/2 ml-2">
          <p class="mb-5 text-xs px-2">Click the 'Add Video' button, or drag a file on to this section to upload a new video.</p>
          <div class="flex flex-wrap">
            <div class="w-full px-2 text-center">
              <label>
                <div class="inline-block bg-transparent hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow cursor-pointer">
                  <span v-if="mediaUrl">+ Update Video</span>
                  <span v-else>+ Add Video</span>
                </div>
                <input type="file" class="hidden" @change="handleVideoUpload" accept="video/*" multiple/>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- UPLOADING -->
      <div class="w-full" v-if="!videoUploaded && uploadProgress !== null">
          <h3 class="mb-5">Uploading Video...</h3>
          <p class="mb-5">{{ filename }}</p>
          <p class="text-right">{{ uploadProgress }}%</p>
          <div class="border border-grey-dark p-2 mb-5">
              <div class="bg-tertiary progress" :style="{width: `${uploadProgress}%`}"></div>
          </div>
      </div>

      <!-- UPLOADED -->
      <div class="w-full" v-if="videoUploaded">
          <h3 class="mb-5">Upload Complete</h3>
      </div>

      <!-- Thumbnail -->
      <div class="flex w-full relative items-center">
        <div class="w-1/2 border border-grey-dark p-4 ml-2" v-if="!thumbnail">
          <div class="w-full bg-tertiary upload-helper text-center flex items-center justify-center rounded-lg" @drop.prevent="filesDropped($event,false)" @dragenter="overDropzoneImage = true" @dragleave="overDropzone = false">
            <div class="dropzone" :class="{over: overDropzoneImage}">
              <i class="fas fa-file-upload fa-4x block"></i>
              <h3 class="mt-5 mb-2">Upload Thumbnail</h3>
              <p>Drop your image file here</p>
            </div>
          </div>
        </div>
        <div class="w-1/2 p-4 ml-2 border border-grey-dark"  @drop.prevent="filesDropped($event, false)" @dragenter="overDropzoneImage = true" @dragleave="overDropzoneImage = false" v-else>
          <div class="w-full mb-5 px-2">
            <div class="float-right">
              <i class="fas fa-trash-alt ml-3 cursor-pointer" title="Delete" @click="deleteThumbnail()"></i>
            </div>
            <div class="pb-2 font-bold">Uploaded Thumbnail:</div>
            <div class="p-4 dropzone" :class="{over: overDropzoneImage}">
              <img :src="thumbnail" width="400px" height="230px" >
            </div>
          </div>
        </div>
        <div class="w-1/2 ml-2">
          <p class="mb-5 text-xs px-2">Upload your thumbnail image to display as the link in your email here. </p>
          <p class="mb-5 text-xs px-2">Preferred size would be 827 x 465 pixels @72 dpi. </p>

          <div class="flex flex-wrap">
            <div class="w-full px-2 text-center">
              <label>
                <div class="inline-block bg-transparent hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow cursor-pointer">
                  <span v-if="thumbnail">+ Update Image</span>
                  <span v-else>+ Add Image</span>
                </div>
                <input type="file" class="hidden" @change="handleImageUpload" accept="image/*" multiple/>
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import api from '@/http'
import http from 'axios'

export default {
  name: 'valuation-video',
  props: {
    videoUrl: {
      default: null
    },
    videoName: {
      default: 'custom-video'
    },
    videoThumbnail: {
      default: null
    },
    videoSize: {
      default: null
    },
    type: {
      default: 'pre'
    },
    department: {
      default: 'rs'
    }
  },
  data () {
    return {
      draggingFiles: false,
      overDropzone: false,
      overDropzoneImage: false,
      uploadProgress: null,
      videoUploaded: false,
      filename: null,
      video_uploaded: false,
      mediaSize: null,
      mediaUrl: null,
      thumbnail: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  watch: {
    mediaUrl () {
      if (this.mediaUrl !== this.videoUrl) {
        this.$emit('customVideoUpdated', this.mediaUrl)
      }
    }
  },
  created () {
    document.addEventListener('dragover', this.dragAndDropStart)
    document.addEventListener('dragleave', this.dragAndDropEnd)
    document.addEventListener('drop', this.dragAndDropEnd)
    this.mediaUrl = this.videoUrl
    let urlArray = this.mediaUrl ? this.mediaUrl.split('/') : []
    this.filename = urlArray.length ? urlArray[urlArray.length - 1] : null
    this.thumbnail = this.videoThumbnail
    this.mediaSize = this.videoSize
  },
  beforeDestroy () {
    document.removeEventListener('dragover', this.dragAndDropStart)
    document.removeEventListener('dragleave', this.dragAndDropEnd)
    document.removeEventListener('drop', this.dragAndDropEnd)
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    dragAndDropStart (e) {
      e.preventDefault()
      this.draggingFiles = true
    },
    dragAndDropEnd (e) {
      e.preventDefault()
      this.draggingFiles = false
    },
    filesDropped (e, isVideo) {
      this.draggingFiles = false
      this.overDropzone = false
      this.overDropzoneImage = false

      if (e.dataTransfer.items) {
        if (e.dataTransfer.items[0].kind !== 'file') {
          return
        }
        this.uploadFile(e.dataTransfer.items[0].getAsFile(), isVideo)
      } else {
        this.uploadFile(e.dataTransfer.files[0], isVideo)
      }
    },
    handleVideoUpload (e) {
      this.uploadFile(e.target.files[0], true)
    },
    handleImageUpload (e) {
      this.uploadFile(e.target.files[0], false)
    },
    async uploadFile (file, isVideo) {
      // Validate
      if ((isVideo && file.type.indexOf('video/') !== 0) || (!isVideo && file.type.indexOf('image/') !== 0)) {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Upload Failed',
          info: `${file.name} is not a valid format`
        })
        return
      }

      let filePath = `valuation/${this.selectedOffice.id}/${this.videoName}`
      if (!isVideo) {
        filePath += '/thumbnail'
      }

      const extension = file.name.split('.').pop()
      const response = await api.post('signed-upload', {
        'disk': 's3',
        'extension': extension,
        'path': filePath,
        'content_type': file.type,
        'visibility': 'public-read'
      })

      let s3File = response.data.key
      let headers = response.data.headers
      let fileUrlArr = response.data.url.split('?')
      if ('Host' in headers) {
        delete headers.Host
      }
      this.uploadProgress = null
      this.videoUploaded = false
      if (isVideo) {
        this.mediaUrl = fileUrlArr.length ? fileUrlArr[0] : response.data.url
        this.filename = file.name
        // get size
        this.mediaSize = file.size
        await http.put(response.data.url, file, {
          headers: headers,
          onUploadProgress: (progressEvent) => {
            this.uploadProgress = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
          }
        })
        api.post(`/valuation-mail/upload-video/${this.selectedOffice.id}/${this.type}/${this.department}`, {
          fileUri: s3File,
          fileUrl: this.mediaUrl,
          fileSize: this.mediaSize
        })
          .then((response) => {
            this.videoUploaded = true
            this.video_uploaded = true
          }, () => {
            this.uploadProgress = null
            this.videoUploaded = false
            this.displayToastNotification({
              type: 'danger',
              icon: 'fa-times-circle',
              title: 'Upload Failed',
              info: file.name
            })
          })
      } else {
        await http.put(response.data.url, file, {
          headers: headers
        })
        this.thumbnail = fileUrlArr.length ? fileUrlArr[0] : response.data.url

        api.post(`/valuation-mail/upload-video-thumbnail/${this.selectedOffice.id}/${this.type}/${this.department}`, {
          fileUri: s3File,
          fileUrl: this.thumbnail
        })
          .then((response) => {
            this.$emit('thumbnailUpdated', this.thumbnail)
          }, () => {
            this.displayToastNotification({
              type: 'danger',
              icon: 'fa-times-circle',
              title: 'Upload Failed',
              info: this.thumbnail
            })
          })
      }
    },
    deleteVideo () {
      // post delete
      if (confirm('Do you want to remove the custom video?')) {
        return api.delete(`/valuation-mail/video/${this.selectedOffice.id}/${this.type}/${this.department}`)
          .then(response => {
            this.mediaUrl = null
            this.filename = null
            this.mediaSize = null
            this.video_uploaded = false
          }, () => {
            this.displayToastNotification({
              type: 'danger',
              icon: 'fa-times-circle',
              title: 'Delete Failed',
              info: this.filename
            })
          })
      }
    },
    deleteThumbnail () {
      // post delete
      if (confirm('Do you want to remove this thumbnail image?')) {
        return api.delete(`/valuation-mail/thumbnail/${this.selectedOffice.id}/${this.type}/${this.department}`)
          .then(response => {
            this.thumbnail = null
            this.$emit('thumbnailUpdated', null)
          }, () => {
            this.displayToastNotification({
              type: 'danger',
              icon: 'fa-times-circle',
              title: 'Delete Failed',
              info: this.thumbnail
            })
          })
      }
    },
    urlChange () {
      this.filename = null
      this.mediaSize = null
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-helper {
    background-color: rgba(255,255,255,.95);
    z-index: 2;
}
.dropzone {
    transform: scale(1);
    transition: transform .3s;
    pointer-events: none;
}
.dropzone.over {
    transform: scale(1.1)
}
.progress {
    height: 20px;
}
.video-preview {
    height: 160px;
}
</style>
